/* src/components/question-input/question-input.component.scss */
.select-answer,
.ng-dropdown-panel {
  z-index: calc(var(--vwui--zindex--select) - 10);
}
.question-is-mandatory {
  --border-color: var(--vwui-color-danger);
  --border-color-hover: var(--vwui-color-danger);
  --border-color-focus: var(--vwui-color-danger);
}
.characters-remaining {
  color: var(--vwui-color-neutral-1);
}
/*# sourceMappingURL=question-input.component-QFQAGL4G.css.map */
